import { store } from "@src/index";
import { ILeague } from "@src/types/api";

import {
    leagueManagementActions,
    selectSelectedLeague,
} from "@features/leaguemgmt/leagueManagementSlice";

import { getBracket } from "@lib/api";

const loader = async ({ params }: any) => {
    let { leagueId } = params;
    let league: ILeague | undefined;
    leagueId = parseInt(leagueId);

    let leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    const selectedLeague = selectSelectedLeague(store.getState());

    const [bracket] = await Promise.all([getBracket(leagueId), leaguesPromise]);

    if (selectedLeague?.id !== leagueId) {
        store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
        league = selectSelectedLeague(store.getState());
    } else {
        league = selectedLeague;
    }

    const header = `${league?.ageLevel} ${
        league?.designation ? league.designation : ""
    } ${league?.direction ? league.direction : ""} Playoff Bracket`;

    return {
        league,
        bracket,
        header,
    };
};

export default loader;
